import {RecruiterDetailsResponse} from "../../../types/index"
export const userDetailsInitialState: RecruiterDetailsResponse = (() => {
    
    return {
      login_type: "",
      isLoginSuccess:false,
      brandname: "",
      user_type: "",
      is_logged_in: false,
      shared_user: [],
      domaintype: "",
      auth_message: "",
      is_beta_customer: false,
      companyLogoUrl: "",
      first_name: "",
      tracking_id: "",
      cremail: "",
      site_context: "",
      new_search_beta_customer: false,
      'foundit.in': "",
      subhchannel_id: "",
      sales_channel: "",
      last_name: "",
      recruiter_id: "",
      is_master_have_child: false,
      ip_address: "",
      services: [],
      is_quick_jp: false,
      salesemail: "",
      rda_url: "",
      log_out_url: "",
      parent_id: "",
      company_name: "",
      v4srp_url: "",
      v4s_url: "",
      pagetitle: "",
      session_limit_exceeded: false,
      corp_id: "",
      channel_id: "",
      username: "",
      product_type: "",
    }
})()